import React, { useState } from 'react';
import { Link, useParams } from "react-router-dom";
import DashboardSidebar from "../../agencyDashboardSidebar"
import PipelineTabs, { Tab } from "../../_shared/PipelineTabs";
import { getJobs } from "../../../../../services/staffingService";
// Import the new modal component
import AssignJobsModal from './open/AssignJobsModal';

import UnassignedOpenListView from './open/unassignedListView';
import UnassignedOpenGridView from './open/unassignedGridView';

import UnassignedDisputedListView from './disputed/unassignedListView';
import UnassignedDisputedGridView from './disputed/unassignedGridView';

import UnassignedCompletedListView from './completed/unassignedListView';
import UnassignedCompletedGridView from './completed/unassignedGridView';

import moment from 'moment';

const Assign = () => {
  const { providerCompanyId } = useParams();
  const [showPredefined, setShowPredefined] = useState(!false);
  const [isAutoAssign, setIsAutoAssign] = useState(false);
  const [loading, setLoading] = useState(false);
  const [showAssignModal, setShowAssignModal] = useState(false);

  const [jobs, setJobs] = useState([]);
  const [openJobs, setOpenJobs] = useState([]);
  const [disputedJobs, setDisputedJobs] = useState([]); 
  const [completedJobs, setCompletedJobs] = useState([]);
  const [unassignedJobsCount, setUnassignedJobsCount] = useState(0);

  const [activeCardIndex, setActiveCardIndex] = useState(0);
  const [gridView, setGridView] = useState(1);
  const [showSideDrawer, setShowSideDrawer] = useState(false);

  React.useEffect(() => {
    fetchJobs()
  }, [])

  async function fetchJobs() {
    setLoading(true);
    const resp = await getJobs(providerCompanyId);
    setJobs([...resp.data.jobs]);
    setOpenJobs([...resp.data.jobs.filter(job => job.status === "open")]);
    setDisputedJobs([...resp.data.jobs.filter(job => job.status === "disputed")]);
    setCompletedJobs([...resp.data.jobs.filter(job => job.status === "completed")]);
    setUnassignedJobsCount(resp.data.unassignedJobsCount);
    setLoading(false);
  }

  // Add this new useEffect to monitor unassignedJobsCount
  React.useEffect(() => {
    // Show the modal automatically when unassignedJobsCount > 1
    if (unassignedJobsCount >= 1) {
      setShowAssignModal(true);
    }
  }, [unassignedJobsCount]);

  const getDeadlineText = (shifts) => {
    if (!shifts || shifts.length === 0) {
        return 'No shifts';
    }

    const firstShift = shifts.reduce((earliest, shift) => {
        return new Date(shift.startTime) < new Date(earliest.startTime) ? shift : earliest;
    });

    const now = moment();
    const shiftStart = moment(firstShift.startTime);
    const deadline = shiftStart.subtract(12, 'hours');
    const duration = moment.duration(deadline.diff(now));

    if (duration.asDays() >= 1) {
        return `${Math.floor(duration.asDays())}d left`;
    } else if (duration.asHours() >= 1) {
        return `${Math.floor(duration.asHours())}h left`;
    } else if (duration.asMinutes() > 0) {
        return `${Math.floor(duration.asMinutes())}m left`;
    } else {
        return 'Expired';
    }
  };

  const handleOpenAssignModal = () => {
    setShowAssignModal(true);
  };

  const handleCloseAssignModal = () => {
    setShowAssignModal(false);
  };

  return (
    <div className="flex h-screen overflow-hidden bg-gray-50 font-inter">
      <DashboardSidebar isOpen={showSideDrawer} setIsOpen={setShowSideDrawer} />
      <main className="flex-1 overflow-y-auto">
        <div className="p-6">

          {/* Page Header — Dispoline pattern */}
          <div className="mb-6 flex flex-col gap-4 sm:flex-row sm:items-center sm:justify-between">
            <div>
              <h2 className="text-2xl font-bold text-foreground">Jobs</h2>
              <p className="mt-1 text-sm text-muted-foreground">Manage work orders and shift assignments</p>
            </div>
            <div className="flex items-center gap-3">
              {/* View Toggle */}
              <div className="flex items-center bg-white border border-gray-200 p-0.5 rounded-lg">
                <button
                  className={`p-2 rounded-md cursor-pointer transition-colors duration-200 ${
                    gridView === 0 ? 'bg-primary text-white' : 'bg-white text-primary hover:bg-gray-50'
                  }`}
                  onClick={() => setGridView(0)}
                  title="Grid view"
                >
                  <svg width="16" height="16" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M7.49984 18.3332H12.4998C16.6665 18.3332 18.3332 16.6665 18.3332 12.4998V7.49984C18.3332 3.33317 16.6665 1.6665 12.4998 1.6665H7.49984C3.33317 1.6665 1.6665 3.33317 1.6665 7.49984V12.4998C1.6665 16.6665 3.33317 18.3332 7.49984 18.3332Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                    <path d="M10 1.6665V18.3332" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                    <path d="M1.6665 10H18.3332" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                  </svg>
                </button>
                <button
                  className={`p-2 rounded-md cursor-pointer transition-colors duration-200 ${
                    gridView === 1 ? 'bg-primary text-white' : 'bg-white text-primary hover:bg-gray-50'
                  }`}
                  onClick={() => setGridView(1)}
                  title="List view"
                >
                  <svg width="16" height="16" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M16.5832 11.25H3.4165C2.1665 11.25 1.6665 11.7833 1.6665 13.1083V16.475C1.6665 17.8 2.1665 18.3333 3.4165 18.3333H16.5832C17.8332 18.3333 18.3332 17.8 18.3332 16.475V13.1083C18.3332 11.7833 17.8332 11.25 16.5832 11.25Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                    <path d="M16.5832 1.6665H3.4165C2.1665 1.6665 1.6665 2.19984 1.6665 3.52484V6.8915C1.6665 8.2165 2.1665 8.74984 3.4165 8.74984H16.5832C17.8332 8.74984 18.3332 8.2165 18.3332 6.8915V3.52484C18.3332 2.19984 17.8332 1.6665 16.5832 1.6665Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                  </svg>
                </button>
              </div>

              {/* Unassigned Jobs Button */}
              <button
                className={`flex items-center h-10 px-4 py-2 rounded-lg text-sm font-medium cursor-pointer transition-all duration-200 shadow-sm ${
                  unassignedJobsCount > 0
                    ? 'bg-pink-50 border border-pink-200 hover:bg-pink-100'
                    : 'bg-white border border-gray-200 text-gray-600 hover:bg-gray-50'
                }`}
                style={unassignedJobsCount > 0 ? { color: 'var(--brand-pink)', borderColor: 'rgba(204,69,125,0.3)', backgroundColor: 'rgba(204,69,125,0.05)' } : {}}
                onClick={handleOpenAssignModal}
              >
                {unassignedJobsCount > 0 ? (
                  <>
                    <span className="text-white rounded-full w-5 h-5 flex items-center justify-center mr-2 text-xs font-bold" style={{ backgroundColor: 'var(--brand-pink)' }}>
                      {unassignedJobsCount > 99 ? '99+' : unassignedJobsCount}
                    </span>
                    Unassigned Jobs
                  </>
                ) : (
                  <span>Unassigned Jobs</span>
                )}
              </button>

              {/* New Job Button */}
              <Link to={`/provider-company/${providerCompanyId}/crm`}>
                <button className="flex items-center gap-2 h-10 px-4 py-2 bg-primary text-white rounded-lg font-medium text-sm hover:bg-primary/90 transition-colors shadow-sm">
                  <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 24 24"><path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm5 11h-4v4h-2v-4H7v-2h4V7h2v4h4v2z"/></svg>
                  New Job
                </button>
              </Link>
            </div>
          </div>

          {/* Tab Bar + Content — shared PipelineTabs */}
          <PipelineTabs defaultActiveKey="1" onTabChange={(key) => setActiveCardIndex(parseInt(key) - 1)}>
            <Tab eventKey="1" label="Open" count={openJobs.length}>
              {gridView === 1 ? (
                <UnassignedOpenListView data={openJobs} getDeadlineText={getDeadlineText} />
              ) : (
                <UnassignedOpenGridView data={openJobs} getDeadlineText={getDeadlineText} />
              )}
            </Tab>

            <Tab eventKey="2" label="Disputed" count={disputedJobs.length}>
              {gridView === 1 ? (
                <UnassignedDisputedListView data={disputedJobs} />
              ) : (
                <UnassignedDisputedGridView data={disputedJobs} />
              )}
            </Tab>

            <Tab eventKey="3" label="Completed" count={completedJobs.length}>
              {gridView === 1 ? (
                <UnassignedCompletedListView data={completedJobs} />
              ) : (
                <UnassignedCompletedGridView data={completedJobs} />
              )}
            </Tab>
          </PipelineTabs>

          {/* No Data Message */}
          {jobs.length === 0 && !loading && (
            <div className="mt-8 text-center text-muted-foreground">No work orders found</div>
          )}

        </div>
      </main>

      {/* Loading Overlay */}
      {loading && (
        <div className="fixed inset-0 flex items-center justify-center bg-black/50 z-50">
          <div className="bg-white p-6 rounded-xl shadow-lg">
            <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-primary mx-auto"></div>
            <p className="mt-2 text-sm text-muted-foreground">Loading...</p>
          </div>
        </div>
      )}

      {/* Assign Jobs Modal */}
      <AssignJobsModal
        open={showAssignModal}
        onClose={handleCloseAssignModal}
        unassignedJobsCount={unassignedJobsCount}
        providerCompanyId={providerCompanyId}
      />
    </div>
  );
};
export default Assign;